export default {
  beforeRouteEnter(to, from, next) {
    next((rootComponent) => rootComponent.$store.commit("$_header_page/SET_CONTENT_WIDTH_TO_DEFAULT"));
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("$_header_page/SET_CONTENT_WIDTH", null);
    next();
  },
};
